export default __webpack_public_path__ + "static/media/border_red.11edf34b.svg";